import { useState } from "react";

import { useTranslation } from "react-i18next";

import { EditIcon } from "@dotnet/telematics-design-system";

import {
    COMPANY_LEVEL_SETTINGS,
    FEATURE_SETTINGS,
    RenderConditionOptions,
    ROLE_TYPES,
    useCompanyLevelSettings,
    usePermissions
} from "shared";

import { TITLES } from "../constants";

const useRoleInlineActions = () => {
    const { t } = useTranslation();

    const { isFeatureSettingsRestricted } = useCompanyLevelSettings();
    const { PERMISSIONS, getNoPermissionTooltipTitle } = usePermissions();

    const [rowData, setRowData] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    const isRestrictedForNotPremium = isFeatureSettingsRestricted(
        FEATURE_SETTINGS.CustomRoleSupport
    );

    const openDialog = (data: any) => {
        setRowData(data);
        setIsOpen(true);
    };

    const closeDialog = () => {
        setRowData(null);
        setIsOpen(false);
    };

    const getTooltipTitle = () => {
        if (isRestrictedForNotPremium) {
            return t(
                `Restrictions##${COMPANY_LEVEL_SETTINGS.FeatureSettings}##${FEATURE_SETTINGS.CustomRoleSupport}##${TITLES.EditRole}`
            );
        }

        return getNoPermissionTooltipTitle(PERMISSIONS.RoleUpdate);
    };

    const inlineActions = [
        {
            title: TITLES.EditRole,
            icon: EditIcon,
            getDisabledText: () => getTooltipTitle(),
            clickAction: (data: any) => openDialog(data),
            renderConditions: ({ data }: RenderConditionOptions) =>
                data.type !== ROLE_TYPES.Static
        }
    ];

    return {
        roleInlineActions: inlineActions,
        roleRowData: rowData,
        isRoleOpen: isOpen,
        closeEditRoleDialog: closeDialog
    };
};

export { useRoleInlineActions };
